import { MAPBOX_TOKEN } from '../constants/mapbox.constants'

interface GeocodingResult {
  features?: Array<{
    center: [number, number]
    place_name: string
    text?: string
  }>
}

export const getGeocoding = async (
  search: string
): Promise<{ data?: GeocodingResult; error?: string | Error }> => {
  try {
    const res = await fetch(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${search}.json?proximity=ip&access_token=${MAPBOX_TOKEN}`
    )

    if (res.status !== 200) {
      return {
        error: `geocoding api error: ${res.status} - ${res.statusText}`,
      }
    }

    const data = await res.json()

    return { data }
  } catch (error) {
    return { error: error instanceof Error ? error : String(error) }
  }
}

export const getReverseGeocoding = async ({
  latitude,
  longitude,
}: {
  latitude: number
  longitude: number
}): Promise<{ data?: GeocodingResult; error?: string | Error }> => {
  try {
    const res = await fetch(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${longitude},${latitude}.json?limit=1&access_token=${MAPBOX_TOKEN}`
    )
    if (res.status !== 200) {
      return {
        error: `geocoding api error: ${res.status} - ${res.statusText}`,
      }
    }
    const data = await res.json()
    return { data }
  } catch (error) {
    return { error: error instanceof Error ? error : String(error) }
  }
}

export const getLocation = (): Promise<{ latitude: number; longitude: number }> =>
  new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        })
      },
      (error) => {
        reject(error)
      }
    )
  })

interface LocationResult {
  latitude: number
  longitude: number
  radius: number
  label: string
}

export const getLocationAndReverseGeocoding = async (): Promise<
  LocationResult | { error: string | Error | GeolocationPositionError }
> => {
  try {
    const location = await getLocation()
    const res = {
      latitude: location.latitude,
      longitude: location.longitude,
      radius: 40,
      label: 'My location',
    }

    try {
      const reverseGeocoding = await getReverseGeocoding({
        latitude: location.latitude,
        longitude: location.longitude,
      })
      if (reverseGeocoding.data?.features?.[0]?.text) {
        res.label = reverseGeocoding.data.features[0].text
      }
    } catch {
      // do nothing
    }

    return res
  } catch (error) {
    return { error: error as GeolocationPositionError }
  }
}
